import React from 'react';
import './HomePage.css';

class HomePage extends React.Component {
    
    render() {
        return (
            <div className = 'home-page'>
                <img className="imgCenter" src={ require('../../images/bg.png') } alt="Background" width="62%" height="62%" />    
            </div>
        );
    }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/component/home/HomePage.js